// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CardValidations$OrcaPaymentPage from "../../shared-code/sdk-utils/validation/CardValidations.bs.js";

let cardNumberOptions_validations = [
  "required",
  "validCardNumber"
];

let cardNumberOptions_showCardIcon = true;

let cardNumberOptions = {
  type: "card-number",
  name: "card_number",
  placeholder: "1234 1234 1234 1234",
  validations: cardNumberOptions_validations,
  showCardIcon: cardNumberOptions_showCardIcon
};

function cardExpiryOptions(expiryPlaceholder) {
  return {
    type: "card-expiration-date",
    name: "card_exp",
    placeholder: expiryPlaceholder,
    validations: [
      "required",
      "validCardExpirationDate"
    ],
    showCardIcon: false,
    yearLength: 2
  };
}

let cardCvcOptions_validations = [
  "required",
  "validCardSecurityCode"
];

let cardCvcOptions_showCardIcon = true;

let cardCvcOptions = {
  type: "card-security-code",
  name: "card_cvc",
  placeholder: "123",
  validations: cardCvcOptions_validations,
  showCardIcon: cardCvcOptions_showCardIcon
};

let savedCardCvcCss = Object.fromEntries([
  [
    "padding",
    "0px"
  ],
  [
    "margin",
    "0px"
  ],
  [
    "line-height",
    "1.8rem"
  ],
  [
    "height",
    "1.8rem"
  ],
  [
    "box-sizing",
    "border-box"
  ]
].map(param => [
  param[0],
  param[1]
]));

function savedCardCvcValidations(savedCardBrand) {
  let exactLengthPatterns = CardValidations$OrcaPaymentPage.getobjFromCardPattern(savedCardBrand).cvcLength.map(length => `\\d{` + length.toString() + `}`).join("|");
  return [
    "required",
    `/^(?:` + exactLengthPatterns + `)$/`
  ];
}

function savedCardCvcOptions(savedCardBrand) {
  let newrecord = {...cardCvcOptions};
  newrecord.css = savedCardCvcCss;
  newrecord.showCardIcon = false;
  newrecord.validations = savedCardCvcValidations(savedCardBrand);
  return newrecord;
}

let vgsScriptURL = `https://js.verygoodvault.com/vgs-collect/2.27.2/vgs-collect.js`;

export {
  vgsScriptURL,
  cardNumberOptions,
  cardExpiryOptions,
  cardCvcOptions,
  savedCardCvcCss,
  savedCardCvcValidations,
  savedCardCvcOptions,
}
/* savedCardCvcCss Not a pure module */
